import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NeoMontoIntermediarioDTO } from '../../Model/neoMontoIntermediarioDTO';
import { AdministracionMontosService } from '../../Service/administracionMontos.service';
import { CurrencyPipe } from '@angular/common';
import { AlertService } from '../../../services/alert.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

@Component({
    selector: 'app-administracion-montos-intermediario',
    templateUrl: './administracion-montos-intermediario.component.html',
    styleUrls: ['./administracion-montos-intermediario.component.scss'],
    providers: [AdministracionMontosService],
    standalone: false
})
export class AdministracionMontosIntermediarioComponent implements OnInit {
  public listaNeoMontosIntermediarioDTO: NeoMontoIntermediarioDTO[] = [];
  public neoMontoIntermediarioDTO: NeoMontoIntermediarioDTO;
  public editarNeoMontoIntermediarioDTO: NeoMontoIntermediarioDTO;
  public eliminarNeoMontoIntermediarioDTO: NeoMontoIntermediarioDTO;
  public user;
  adminMontosForm: UntypedFormGroup;
  editarMontosForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _userIntermediarioService: UserService,
    private _administracionMontosService: AdministracionMontosService,
    public pipe: CurrencyPipe,
    private alertService: AlertService,
    public router: Router,
    private _sweetAlert:SweetAlertService
  ) {
    this.neoMontoIntermediarioDTO = new NeoMontoIntermediarioDTO(
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.editarNeoMontoIntermediarioDTO = new NeoMontoIntermediarioDTO(
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.eliminarNeoMontoIntermediarioDTO = new NeoMontoIntermediarioDTO(
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.user = this._userIntermediarioService.getUser();
    this.adminMontosForm = this.formBuilder.group({
      montoInicial: ['', Validators.required],
      montoFinal: ['', Validators.required],
    });
    this.editarMontosForm = this.formBuilder.group({
      montoInicial: [0, Validators.required],
      montoFinal: [0, Validators.required],
      justificacion: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this._administracionMontosService
      .getMontosIF(this.user.idCliente)
      .subscribe(
        (response) => {
          this.listaNeoMontosIntermediarioDTO = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,'No fue posible cargar los montos');
        }
      );
    this.setPipeForm();
  }

  isValidForm(field: string) {
    return (
      (this.adminMontosForm.get(field)?.dirty ||
        this.adminMontosForm.get(field)?.touched) &&
      this.adminMontosForm.get(field)?.invalid
    );
  }

  isValidFormEditar(field: string) {
    return (
      (this.editarMontosForm.get(field)?.dirty ||
        this.editarMontosForm.get(field)?.touched) &&
      this.editarMontosForm.get(field)?.invalid
    );
  }

  onSubmit() {
    this.neoMontoIntermediarioDTO.idUsuario = this.user.idUsuario;
    this.neoMontoIntermediarioDTO.montoInicial = +this.adminMontosForm
      .get('montoInicial')
      .value.replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '');
    this.neoMontoIntermediarioDTO.montoFinal = +this.adminMontosForm
      .get('montoFinal')
      .value.replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '');
    if (
      this.neoMontoIntermediarioDTO.montoInicial <
      this.neoMontoIntermediarioDTO.montoFinal
    ) {
      this.neoMontoIntermediarioDTO.idCliente_NeoCliente = this.user.idCliente;
      this._administracionMontosService
        .saveMontosIF(this.neoMontoIntermediarioDTO)
        .subscribe(
          (response) => {
            if (response['exitoso'] == true) {
              this._sweetAlert.successModal('Rango agregado');
              this.adminMontosForm = this.formBuilder.group({
                montoInicial: ['', Validators.required],
                montoFinal: ['', Validators.required],
              });
              this.neoMontoIntermediarioDTO = new NeoMontoIntermediarioDTO(
                null,
                null,
                null,
                null,
                null,
                null
              );
              this.ngOnInit();
            } else {
              this._sweetAlert.errorModal("Error!",true,response['error']);
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!",true,'No fue posible agregar el rango');
          }
        );
      this.editarNeoMontoIntermediarioDTO = new NeoMontoIntermediarioDTO(
        null,
        null,
        null,
        null,
        null,
        null
      );
    } else {
      this._sweetAlert.errorModal("Error!",true,'El monto inicial es mayor que el monto final');
    }
  }

  editarFila(i) {
    this.editarNeoMontoIntermediarioDTO =
      this.listaNeoMontosIntermediarioDTO[i];
    this.editarMontosForm
      .get('montoInicial')
      .setValue(this.editarNeoMontoIntermediarioDTO.montoInicial);
    this.editarMontosForm
      .get('montoFinal')
      .setValue(this.editarNeoMontoIntermediarioDTO.montoFinal);
    $('#editModal').modal('show');
  }

  editarRango() {
    this.editarNeoMontoIntermediarioDTO.idUsuario = this.user.idUsuario;
    this.editarNeoMontoIntermediarioDTO.montoInicial = +this.editarMontosForm
      .get('montoInicial')
      .value.replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '');
    this.editarNeoMontoIntermediarioDTO.montoFinal = +this.editarMontosForm
      .get('montoFinal')
      .value.replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '');
    this.editarNeoMontoIntermediarioDTO.justificacion =
      this.editarMontosForm.get('justificacion').value;
    if (
      this.editarNeoMontoIntermediarioDTO.montoInicial <
      this.editarNeoMontoIntermediarioDTO.montoFinal
    ) {
      this._administracionMontosService
        .updateMontosIF(this.editarNeoMontoIntermediarioDTO)
        .subscribe(
          (response) => {
            if (response['exitoso'] == true) {
              this._sweetAlert.successModal('Rango editado');
              $('#editModal').modal('hide');
              this.ngOnInit();
            } else {
              this._sweetAlert.errorModal("Error!",true,response['error']);
              $('#editModal').modal('hide');
              this.ngOnInit();
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!",true,'No fue posible editar el rango');
            $('#editModal').modal('hide');
            this.ngOnInit();
          }
        );
    } else {
      this._sweetAlert.errorModal("Error!",true,'El monto inicial es mayor que el monto final');
    }
  }

  borrarFila(i) {
    this.eliminarNeoMontoIntermediarioDTO.idMontoIntermediario =
      this.listaNeoMontosIntermediarioDTO[i].idMontoIntermediario;
    this.eliminarNeoMontoIntermediarioDTO.idCliente_NeoCliente =
      this.listaNeoMontosIntermediarioDTO[i].idCliente_NeoCliente;
    this.eliminarNeoMontoIntermediarioDTO.idUsuario = this.user.idUsuario;
    this.eliminarNeoMontoIntermediarioDTO.justificacion = '';
    $('#deleteModal').modal('show');
  }

  borrarRango() {
    if (this.eliminarNeoMontoIntermediarioDTO != null) {
      if (this.eliminarNeoMontoIntermediarioDTO.justificacion != '') {
        this._administracionMontosService
          .deleteMontosIF(this.eliminarNeoMontoIntermediarioDTO)
          .subscribe(
            (response) => {
              if (response['exitoso'] == true) {
                this._sweetAlert.successModal('Rango borrado exitosamente');
                $('#deleteModal').modal('hide');
                this.ngOnInit();
              } else {
                this._sweetAlert.errorModal("Error!",true,'No fue posible borrar el rango');
                $('#deleteModal').modal('hide');
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!",true,'No fue posible borrar el rango');
              $('#deleteModal').modal('hide');
            }
          );
      } else {
        this._sweetAlert.errorModal("Error!",true,'Ingrese la justificacion');
      }
    } else {
      this._sweetAlert.errorModal("Error!",true,'No fue posible cargar los datos');
      $('#deleteModal').modal('hide');
    }
  }

  setPipeForm() {
    this.adminMontosForm.controls['montoInicial'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.adminMontosForm.patchValue(
            {
              montoInicial: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
    this.adminMontosForm.controls['montoFinal'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.adminMontosForm.patchValue(
            {
              montoFinal: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
    this.editarMontosForm.controls['montoInicial'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.editarMontosForm.patchValue(
            {
              montoInicial: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
    this.editarMontosForm.controls['montoFinal'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.editarMontosForm.patchValue(
            {
              montoFinal: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
  }

  goHome() {
    this.router.navigate(['/intermediario/home']);
  }

  validateForm() {
    if (this.adminMontosForm.valid) {
      this.onSubmit();
    } else {
      this.adminMontosForm.markAllAsTouched();
    }
  }
}
